<template>
  <div class="gallery Page">
    <div class="Page-Content">
      <div class="gallery-group">
        <div class="gallery-item growFromScaleAnimation" v-for="(data, i) in nowdata" :key="i" @click="showIMG(data)">
          <div class="item-img">
            <img class="" :src="data.cover" alt="" />
            <p v-if="!data.show" style="position: absolute;color: white;font-size: 14px;font-weight: 600;">Content Coming Soon</p>
          </div>
          <p style="margin: 2px;text-align: center;width: 100%;font-weight: 600; margin-top: 10px;">{{ data.name }}</p>
        </div>
      </div>
    </div>

    <!-- 其他媒体 -->
    <div v-if="showMedia" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: black;z-index: 2000;">
      <video v-if="showMediaData.type=='video'" style="width: 100%;height: 100%;" :src="showMediaData.media" playsinline autoplay muted loop controls></video>
      <iframe style="width: 100%;height: 100%;" v-if="showMediaData.type=='vr'" :src="showMediaData.media" frameborder="0"></iframe>
      <div class="Media-swiper" v-if="showMediaData.type=='img'">
        <swiper class="swiper swiperGallery" :options="swiperOption" ref="swiperOption" >
          <swiper-slide  v-for="item,i in nowImg" :key="i" >
            <img ondragstart="return false;" :src="item" alt="">
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" style="left: 5%; top: 45%">
          <img src="@/assets/btn/left1.png" alt="" />
        </div>
        <div class="swiper-button-next" style="right: 5%; top: 45%">
          <img src="@/assets/btn/right1.png" alt="" />
        </div>
      </div>
      <div @click="showMedia=false" style="position: absolute;top: 49%;right: 20px;color: black;background-color: white;padding: 5px;cursor: pointer;border-radius: 5px;z-index: 999;">Close</div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showMedia:false,
      showMediaData:{},
      nowdata: [
        { name: "Perspectives",show:true, type: "img", cover: require("@/assets/gallery/OutdoorRenderImg/Aerial View (Pine Grove).jpg"),media:"img1" },
        { name: "Show Units Photo",show:true, type: "img", cover: require("@/assets/gallery/2.png"),media:"img2" },
        { name: "Animation Flythrough",show:true, type: "video", cover: require("@/assets/gallery/3.png"),media:require('@/assets/gallery/video/Animation Flythrough.mp4') },
        { name: "Marketing Video",show:true,type: "video", cover: require("@/assets/gallery/4.png"),media:require('@/assets/gallery/video/Marketing Video.mp4') },
        { name: "Amenities Photo",show:true,type: "img", cover: require('@/assets/gallery/AmenitiesPhoto/Clementi Forest.jpg'),media:"img3" },
        // { name: "TYPE B",show:true, type: "vr", cover: require("@/assets/gallery/Type B.jpg"),media:"https://www.mixgovr.com/AUDAX/pinegroveshowflat/type_b" },
        { name: "TYPE BS",show:true, type: "vr", cover: require("@/assets/gallery/Type BS.jpg"),media:"https://my.matterport.com/show/?m=LFdbqmH9JZR" },
        // { name: "TYPE C-1",show:true, type: "vr", cover: require("@/assets/gallery/Type C1.jpg"),media:"https://www.mixgovr.com/AUDAX/pinegroveshowflat/type_c1/" },
        // { name: "TYPE CP-1",show:true, type: "vr", cover: require("@/assets/gallery/Type CP1.jpg"),media:"https://www.mixgovr.com/AUDAX/pinegroveshowflat/type_cp1/" },
        { name: "TYPE D-2",show:true, type: "vr", cover: require("@/assets/gallery/Type D2.jpg"),media:"https://www.mixgovr.com/AUDAX/pinegroveshowflat/type_d2-/" },
        { name: "TYPE DS",show:true, type: "vr", cover: require("@/assets/gallery/Type DK.jpg"),media:"https://my.matterport.com/show/?m=LFdbqmH9JZR" },
        { name: "TYPE E",show:true, type: "vr", cover: require("@/assets/gallery/Type E.jpg"),media:"https://my.matterport.com/show/?m=f9w7SwdyGfR" },
      ],
      imglistData:{
        img1:[
        require('@/assets/gallery/OutdoorRenderImg/Aerial View (Pine Grove).jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Aerial View (Ulu Pandan Road).jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Arrival Plaza.jpg'),
        require("@/assets/gallery/OutdoorRenderImg/Children-s Playground, Splash Play, Children-s Playroom.jpg"),
        require('@/assets/gallery/OutdoorRenderImg/Chill-out Pavilion.jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Dining Cabana.jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Forest Dining & Media Room.jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Forest Walk.jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Gymnasium.jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Interior.jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Overall Landscape Deck.jpg'),
        require('@/assets/gallery/OutdoorRenderImg/Pavillons overlooking Ulu Pandan Road.jpg'),
        ],
        img2:[
        require('@/assets/gallery/UnitsPhoto/Type BS (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (10).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (11).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (12).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (13).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (14).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (15).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (16).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (17).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (18).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (19).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (20).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (21).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (22).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (23).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (4).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (5).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (6).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (7).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (8).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type BS (9).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-bathroom common (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-bathroom common (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-bathroom common (4).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-corridors (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-corridors (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-kitchen (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-kitchen (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-kitchen (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-kitchen (5).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-kitchen (6).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-kitchen (7).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-kitchen (8).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-kitchen (10).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (5).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (6).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (7).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (8).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (9).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (10).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (11).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (12).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (13).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (14).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (15).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-living dinning (16).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (4).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (6).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (8).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (9).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (10).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (11).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (13).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-master (14).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room1 (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room1 (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room1 (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room2 (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room2 (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room2 (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room2 (5).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (4).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (5).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (6).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (7).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (8).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (10).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (11).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (12).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (13).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-room3 (14).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-study (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/DS-study (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (1).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (10).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (11).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (12).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (13).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (14).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (15).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (16).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (17).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (18).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (19).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (2).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (20).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (21).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (22).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (23).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (24).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (25).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (26).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (27).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (28).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (29).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (3).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (30).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (31).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (32).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (33).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (34).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (35).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (36).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (37).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (38).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (39).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (4).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (40).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (41).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (42).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (43).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (44).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (45).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (46).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (47).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (48).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (49).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (5).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (50).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (51).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (52).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (53).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (54).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (55).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (56).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (57).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (58).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (59).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (6).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (60).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (61).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (62).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (63).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (64).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (65).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (66).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (67).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (68).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (69).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (7).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (70).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (71).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (72).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (73).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (74).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (75).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (76).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (77).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (78).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (79).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (8).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (80).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (81).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (82).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (83).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (84).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (85).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (86).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (87).jpg'),
        require('@/assets/gallery/UnitsPhoto/Type E (9).jpg'),
        ],
        img3:[
        require('@/assets/gallery/AmenitiesPhoto/Clementi Forest.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Clementi MRT Interchange.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Dempsey Hill.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Dover Forest.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Dover MRT.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Henry Park Primary School.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/ION Orchard.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Jem.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Jurong East MRT Interchange.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Jurong Lake Gardens.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/King Albert Park MRT Interchange.jpg'),
        require("@/assets/gallery/AmenitiesPhoto/Methodist Girls' School.jpg"),
        require('@/assets/gallery/AmenitiesPhoto/NUS.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/One Holland Village.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/one-north Business Park.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Pei Tong Primary School.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Rail Corridor.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Singapore Botanic Gardens.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Singapore Polytechnic.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Singapore Science Park.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Sunset Way.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/SUSS.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/The Star Vista.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/Ulu Pandan Park Connector.jpg'),
        require('@/assets/gallery/AmenitiesPhoto/UWCSEA.jpg'),
        ],
      },
      nowImg:[],
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 0, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        loop:true,
        // autoplay: {
        //     delay: 5000, // 轮播间隔时间，单位为毫秒
        //     disableOnInteraction: false, // 用户操作后是否禁止自动轮播
        //   },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

      },
    };
  },
  methods: {
    showIMG(item){
      if(!item.show) return;
      this.showMedia = true;
      this.showMediaData = item
      if (item.type == 'img') {
        this.nowImg = this.imglistData[item.media]
        // this.$viewerApi({
        //   images: this.imglistData[item.media],
        // })
        return;
      }
      

    }
  },
  mounted() {
    // this.$nextTick(()=>{
    //   const top = this.$refs.swiperOption.swiper
    //   const bottom = this.$refs.swiperOptionBottom.swiper
    //   top.controller.control = bottom
    //   bottom.controller.control = top
    // })
  },
};
</script>

<style lang="less">

.Media-swiper{
  position: absolute;
  width: 100%;
  height: 100%;
  .swiper-slide,.swiperGallery {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    img {
      max-height: 5rem;
      max-width: 5rem;
    }
  }
}



.gallery {
  .gallery-group{
    width: 80%;
    margin: auto;
    margin-top: 35px;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-evenly;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    // color: white;
    .gallery-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // width: 320px;
      height: 23vh;
      margin: 20px;
      .item-img{
        position: relative;
        width: 100%;
        height: 90%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
        filter: brightness(50%);
      }
      }

    }
  }

}
</style>

